export default "__VITE_ASSET__DH7Wvyol__"